import bsCustomFileInput from 'bs-custom-file-input';
import Choices from "choices.js";

const fpickers = [];
const choices = [];
$(document).on('turbolinks:load', function(){

    const pickers = document.querySelectorAll('.datepicker');
    if (pickers.length > 0) {
        pickers.forEach((picker)=>{
            const fp = flatpickr(picker, {
                allowInput: true,
                altInput: true,
                altFormat: "F j, Y",
                dateFormat: "Y-m-d"
            });
            fpickers.push(fp);
        });
    }

    // bootstrap file input
    bsCustomFileInput.init();

    // choices.js
    const elements = document.querySelectorAll('.sel2');
    if (elements.length > 0) {
        elements.forEach((element)=>{
            let choice = new Choices(element, { removeItemButton: true });
            choices.push(choice);
        });
    }

    // cocoon callbacks
    $('.cocoon_fields').on('cocoon:after-insert', (e, added_item)=>{
        const element = $('.sel2', added_item).get(0);
        let choice = new Choices(element, { removeItemButton: true });
    });

    // get current URL path and assign 'active' class
    var pathname = window.location.pathname;
    $('#main_nav > li > a[href="'+pathname+'"]').parent().addClass('active');

    // display search
    if (window.location.href.includes('commit=Search')) {
        $('#search_form').collapse('show');
        $('html, body').animate({ scrollTop: $('#search_form').offset().top - 51 }, 'slow');
    }
});

document.addEventListener("turbolinks:before-cache", function() {
    fpickers.forEach((fp)=>{
        fp.destroy();
    });

    choices.forEach((element)=>{
        element.destroy();
    });
});